import { IDeserialize } from "./abstraction/IDeserialize";
import { Company } from "./Company";
import { SubscriptionType } from "./Enums";
import { UserWithRole } from "./UserWithRole";

export class UserProfile extends UserWithRole implements IDeserialize<UserProfile> {
  azureObjectId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  currentRegion: string;
  famCodes: string[] = [];
  companies: Company[] = [];
  subscriptions: SubscriptionType[] = [];

  // subscription resolving properties
  public allowReminders: boolean;
  public allowCswCheckIn: boolean;
  public allowContracts: boolean;
  public allowEditTool: boolean;
  public allowPurchaseOrder: boolean;
  public allowFieldService: boolean;
  public allowHomeGraphs: boolean;
  public allowServiceRequest: boolean;
  public allowTechCover: boolean;

  public deserialize(dto: UserProfile): UserProfile {
    Object.assign(this, dto);

    this.setUserRole();
    this.setUserSubscriptions();
    this.companies = this.companies?.map((x) => new Company().deserialize(x));

    return this;
  }

  private setUserSubscriptions(): void {
    this.allowReminders = this.hasSubscription(SubscriptionType.Reminders);
    this.allowCswCheckIn = this.hasSubscription(SubscriptionType.CswCheckIn);
    this.allowContracts = this.hasSubscription(SubscriptionType.Contracts);
    this.allowEditTool = this.hasSubscription(SubscriptionType.EditTool);
    this.allowPurchaseOrder = this.hasSubscription(SubscriptionType.PurchaseOrder);
    this.allowFieldService = this.hasSubscription(SubscriptionType.FieldService);
    this.allowHomeGraphs = this.hasSubscription(SubscriptionType.HomeGraphs);
    this.allowServiceRequest = this.hasSubscription(SubscriptionType.ServiceRequest);
    this.allowTechCover = this.hasSubscription(SubscriptionType.TechCover);
  }

  private hasSubscription(subscription: SubscriptionType) {
    return this.subscriptions.some((x) => x === subscription);
  }
}
